// (Admin) Team view: curriculum progress, practice activity and certification per setter.
import type { TeamMember } from '../../../src/shared/api-ai';
import { Empty, timeAgo } from '../components/ui';
import { CertChip } from './Certs';

export function Team(props: { team: TeamMember[] }) {
  if (props.team.length === 0) return <Empty>No active users.</Empty>;
  return (
    <table>
      <thead>
        <tr><th>Setter</th><th>Curriculum</th><th>Practice (7 days)</th><th>Avg / best (30 days)</th><th>Last practice</th><th>Certification</th></tr>
      </thead>
      <tbody>
        {props.team.map((m) => (
          <tr>
            <td>
              <div style="font-weight:600">{m.name}</div>
              <div class="muted" style="font-size:12px">{m.email} · {m.role}{m.certifyExempt ? ' · exempt' : ''}</div>
            </td>
            <td>
              <div class="row" style="gap:6px">
                <div class="tr-bar ok" style="width:80px"><span style={`width:${m.curriculumTotal ? Math.round((m.curriculumDone / m.curriculumTotal) * 100) : 0}%`} /></div>
                <span class="mono">{m.curriculumDone}/{m.curriculumTotal}</span>
              </div>
            </td>
            <td class="mono">{m.practice7d} calls · {m.passed7d} passed</td>
            <td class="mono">{m.avgScore30d ?? '—'} / {m.bestScore30d ?? '—'}</td>
            <td>{m.lastPracticeAt ? timeAgo(m.lastPracticeAt) : '—'}</td>
            <td><div class="row" style="flex-wrap:wrap;gap:4px">{m.certifications.length ? m.certifications.map((c) => <CertChip c={c} />) : <span class="muted">No campaigns</span>}</div></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
